import { useLocalStorage } from 'usehooks-ts';

import { STORAGE_KEYS } from '@/shared/constants';

/**
 * Whether the draft editor's right rail is collapsed to its icon strip.
 * Shared by the rail and anything that opens it, so they read one preference.
 */
export function useDraftRailCollapsed() {
  return useLocalStorage(STORAGE_KEYS.DRAFT_RAIL_COLLAPSED, false);
}

/**
 * Whether the asset workspace's config rail is expanded past its icon strip.
 * One preference across automations, agents and context graphs.
 */
export function useConfigRailExpanded() {
  return useLocalStorage(STORAGE_KEYS.ASSET_CONFIG_RAIL_EXPANDED, false);
}
